import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import InfoIconTooltip from "./Icons/InfoIconTooltip";
import CustomIcon from "./CustomIcon";
import AppCache from "../Helper/Common/AppCache";
import { useBaseEntityInfo } from "../Hooks/usePagesContent";

const formatThreshold = (minutes) => {
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const hourPart = `${hours} hour${hours !== 1 ? "s" : ""}`;
  return mins > 0 ? `${hourPart} ${mins} minute${mins !== 1 ? "s" : ""}` : hourPart;
};

const getStatusRows = (entity) => [
  {
    label: "Online",
    description: `${entity} is actively communicating with the platform.`,
    icon: <FiberManualRecordIcon sx={{ color: "#008A15", width: 14, height: 14 }} />,
  },
  {
    label: "Charging",
    description: `Connected to a charger and battery is charging.`,
    icon: <CustomIcon name="charge-icon" sx={{ color: "#008A15", width: 14, height: 14 }} />,
    indent: true,
  },
  {
    label: "Discharging",
    description: `${entity} is in operation and consuming battery power.`,
    icon: <CustomIcon name="discharge-icon" sx={{ color: "#DCA101", width: 14, height: 14 }} />,
    indent: true,
  },
  {
    label: "Idle",
    description: `${entity} is powered on but not in operation; no active charging or significant discharge.`,
    icon: <CustomIcon name="pause-icon" sx={{ width: 14, height: 14 }} />,
    indent: true,
  },
];

const TooltipContent = () => {
  const { baseEntityTypeLable } = useBaseEntityInfo();
  const threshold = AppCache.getItem("pingStatusThreshold");
  const rows = getStatusRows(baseEntityTypeLable);
  const offlineDescription = threshold != null
    ? `No data received from the ${baseEntityTypeLable.toLowerCase()} for the last ${formatThreshold(threshold)}.`
    : `No data received from the ${baseEntityTypeLable.toLowerCase()} recently.`;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {rows.map(({ label, description, icon, indent }) => (
        <Box key={label} sx={{ display: "flex", gap: "6px", pl: indent ? "16px" : 0 }}>
          <Box sx={{ mt: "2px", flexShrink: 0 }}>{icon}</Box>
          <Typography sx={{ fontSize: "11px", lineHeight: "16px", color: "#fff" }}>
            <Box component="span" sx={{ fontWeight: 600 }}>{label}: </Box>{description}
          </Typography>
        </Box>
      ))}
      <Box sx={{ display: "flex", gap: "6px" }}>
        <Box sx={{ mt: "2px", flexShrink: 0 }}>
          <FiberManualRecordIcon sx={{ color: "#8F8F8F", width: 14, height: 14 }} />
        </Box>
        <Typography sx={{ fontSize: "11px", lineHeight: "16px", color: "#fff" }}>
          <Box component="span" sx={{ fontWeight: 600 }}>Offline: </Box>{offlineDescription}
        </Typography>
      </Box>
    </Box>
  );
};

const VehicleStatusInfoTooltip = () => (
  <InfoIconTooltip title={<TooltipContent />} maxWidth={300} />
);

export default VehicleStatusInfoTooltip;
